<template>
  <div>
    <SfButton
      @click="vehicleModalVisible = true"
      class="sf-button--full-width"
      >
      {{ vehicleSearch }}
    </SfButton>
    <SearchByFiltersModal
      :visible="vehicleModalVisible"
      @close="vehicleModalVisible = false"
    />
  </div>
</template>

<script>
import { SfButton } from '@storefront-ui/vue';
import SearchByFiltersModal from '../modals/SearchByFiltersModal.vue';

export default {
  name: 'SearchByFilters',
  components: {
    SfButton,
    SearchByFiltersModal,
  },
  data() {
    return ({
      vehicleModalVisible: false,
    });
  },
  computed: {
    vehicleSearch() {
      return this.$t('Vehicle search');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers";
@import "src/scss/_breakpoint";

@include flexbox-mobile {
  .sf-button {
    margin-top: var(--spacer-sm);
  }
}
</style>
